(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('BankAccountInfoDetailController', BankAccountInfoDetailController);

    BankAccountInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'BankAccountInfo'];

    function BankAccountInfoDetailController($scope, $rootScope, $stateParams, entity, BankAccountInfo) {
        var vm = this;

        vm.bankAccountInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:bankAccountInfoUpdate', function (event, result) {
            vm.bankAccountInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
